import React, { useState } from 'react'
import { Pop, Ls, PointContainer, CableEnd, Name, Action, PopNumber } from '../../style'

const Point = ({ s, x, y, d, nPoP, layer, draw }) => {
  const [active, activate] = useState(false)
  let desp = s ? (d.ls_telxius ? 8 : 6) : d.ls_telxius ? 4 : 2
  const pos = d.text_align
  const despTextY = [-12, -12, -12, 4, 4, 4, 20, 20, 20]
  const despTextX = [6, 0, -6, -10, 0, +10, 6, 0, -6]
  return (
    <>
      <PointContainer id={d.name} key={`gp-${d.id}`} active={active} selected={s}>
        {d.pop && (
          <Pop
            layer={layer}
            selected={s}
            active={active}
            number={nPoP > 1}
            key={`p-${d.id}`}
            r={nPoP > 1 ? (s ? '18' : '9') : s ? '16' : '7'}
            cx={x}
            cy={y}
          />
        )}
        {d.ls && (
          <Ls
            layer={layer}
            telxius={d.ls_telxius}
            planned={d.planned}
            finished={d.finished}
            selected={s}
            key={`ls-${d.id}`}
            width={2 * desp}
            height={2 * desp}
            x={x - desp}
            y={y - desp}
          />
        )}
        {/*END Cable */}
        {layer === 'capacity' && d.dot > 0 && <CableEnd key={`end-${d.id}`} width={5} height={5} x={x - 2.5} y={y - 2.5} />}
        {/* NPOP */}
        {nPoP > 1 && (
          <>
            <PopNumber selected={s} x={x} y={s ? y + 6 : y + 3} textAnchor="middle">
              {nPoP}
            </PopNumber>
          </>
        )}
        {/* TEXT */}
        {
          draw.text ||
          active ||
          (d.ls_telxius && (layer === 'cables' || layer === 'network')) ||
          (d.ls_cable && (layer === 'cables' || layer === 'network'))
        ? (
          <Name
            selected={s}
            x={s ? x : x + despTextX[pos - 1]}
            y={s ? (d.pop ? y - 30 : y - 15) : y + despTextY[pos - 1]}
            textAnchor={s ? 'middle' : pos % 3 === 0 ? 'start' : pos % 3 === 1 ? 'end' : 'middle'}>
            {d.name}
          </Name>
        ) : (
          ''
        )}
        }{/* Actions */}
        {
          <Action
            key={`pa-${d.id}`}
            r="24"
            cx={x}
            cy={y}
            id={d.name}
            onMouseEnter={() => {
              activate(true)
            }}
            onMouseLeave={() => {
              activate(false)
            }}
          />
        }
      </PointContainer>
    </>
  )
}

export default Point
